module.exports = __webpack_public_path__ + "static/media/banner-1.868d9def.jpg";